import React from "react";
import { useSelector } from "react-redux";

import AgencyOnboardingForm from "./agencyForm";
import FreelancerOnboardingForm from "./vendorForm";

export default function OnboardingForm() {
  const user = useSelector((state) => state.user || {});
  const isAgency = user?.isAgency ?? false;
  return (
    <div className="px-[80px] md-max:px-[1rem] flex flex-col my-[60px] md-max:my-[20px] relative">
      {isAgency ? <AgencyOnboardingForm /> : <FreelancerOnboardingForm />}
    </div>
  );
}
